import { DocumentNode, QueryOptions, TypedDocumentNode } from "@apollo/client";

export function makeRefetchQuery<OperationVariables>({
  document,
  variables,
}: {
  document: DocumentNode | TypedDocumentNode<any, OperationVariables>;
  variables: OperationVariables;
}): QueryOptions<OperationVariables, any> {
  return {
    query: document,
    variables,
  };
}
